var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBussiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    className: "bussiness-svg",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C8.37923 0 6.82485 0.608436 5.67879 1.69146C4.53274 2.77448 3.88889 4.24337 3.88889 5.775C3.88889 7.30662 4.53274 8.77552 5.67879 9.85854C6.82485 10.9416 8.37923 11.55 10 11.55C11.6208 11.55 13.1752 10.9416 14.3212 9.85854C15.4673 8.77552 16.1111 7.30662 16.1111 5.775C16.1111 4.24337 15.4673 2.77448 14.3212 1.69146C13.1752 0.608436 11.6208 0 10 0ZM5.55556 12.6C4.08213 12.6 2.66905 13.1531 1.62718 14.1377C0.585316 15.1223 0 16.4576 0 17.85V21H20V17.85C20 16.4576 19.4147 15.1223 18.3728 14.1377C17.3309 13.1531 15.9179 12.6 14.4444 12.6H12.9089L10 18.0978L7.09111 12.6H5.55556Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBussiness);
export default __webpack_public_path__ + "static/media/bussiness.92dc5ef4332bb24d19e49e68d8a1736d.svg";
export { ForwardRef as ReactComponent };